import {Col, message, Modal, QRCode, Row, Space} from "antd";
import {useRecoilValue} from "recoil";
import {globalReferralSettingState, globalUserDetailState,} from "../../../../_common/global_state";
import {useTranslation} from "react-i18next";
import useShared from "../../../../_common/_shared";
import React from "react";
import copy from "copy-to-clipboard";

const QrModal = (props) => {
    const {isModalOpen, handleCancel} = props;
    const {t} = useTranslation();
    const {IconCommon} = useShared()

    const userDetails = useRecoilValue(globalUserDetailState);
    const qrReferral = useRecoilValue(globalReferralSettingState);
    
    const mainDomain = window.location.hostname.split(".").slice(-2).join(".");

    const homePageUrl = "https://" + mainDomain + "/?affiliate=" + userDetails?.affiliateCode;
    const liveUrl = "https://member." + mainDomain + "/#/register?type=individual&affiliate=" + userDetails?.affiliateCode;
    const demoUrl = "https://member." + mainDomain + "/#/register?type=demo&affiliate=" + userDetails?.affiliateCode;

    const copyLink = (link) => {
        copy(link)
        message.success(t("user.successMsg.affiliateLinkCopiedToClipboard"))
    }

    return (
        <Modal
            title={t("referral.modal.title")}
            open={isModalOpen}
            footer={null}
            onCancel={handleCancel}
            className={"modalQr"}
            width={"max-content"}
            getContainer={() => document.getElementById("layout-5")}
        >
            <Row
                gutter={[64, 16]}
                className={"mt-12 text-center mb-12 justify-center"}
            >
                {qrReferral?.referralLink && (
                    <Col xs={24} md={8} className={"mb-4 md:mb-0"}>
                        <div className={"qr-wrap"}>
                            <h4 className={"qrTitle"}>{t("referral.homepage")}</h4>
                            <div className={"header-qr-container"}>
                                <QRCode className={"border-0 mx-auto"} value={homePageUrl}/>
                            </div>
                            <Row justify={"center"}>
                                <Space>
                                    <IconCommon
                                        iconName={"cm-link-regular"}
                                        style={{width: 20}}
                                        className={"cursor-pointer"}
                                        onClick={() => copyLink(homePageUrl)}
                                    />
                                    <IconCommon
                                        iconName={"cm-share-regular"}
                                        style={{width: 20}}
                                        className={"cursor-pointer"}
                                        onClick={() => window.open(homePageUrl, "_blank")}
                                    />
                                </Space>
                            </Row>
                        </div>
                    </Col>
                )}
                {qrReferral?.liveReferralLink && (
                    <Col xs={24} md={8} className={"mb-4 md:mb-0"}>
                        <div className={"qr-wrap"}>
                            <h4 className={"qrTitle"}>{t("referral.live")}</h4>
                            <div className={"header-qr-container"}>
                                <QRCode className={"border-0 mx-auto"} value={liveUrl}/>
                            </div>
                            <Row justify={"center"}>
                                <Space>
                                    <IconCommon
                                        iconName={"cm-link-regular"}
                                        style={{width: 20}}
                                        className={"cursor-pointer"}
                                        onClick={() => copyLink(liveUrl)}
                                    />
                                    <IconCommon
                                        iconName={"cm-share-regular"}
                                        style={{width: 20}}
                                        className={"cursor-pointer"}
                                        onClick={() => window.open(liveUrl, "_blank")}
                                    />
                                </Space>
                            </Row>
                        </div>
                    </Col>
                )}
                {qrReferral?.demoReferralLink && (
                    <Col xs={24} md={8}>
                        <div className={"qr-wrap"}>
                            <h4 className={"qrTitle"}>{t("referral.demo")}</h4>
                            <div className={"header-qr-container"}>
                                <QRCode className={"border-0 mx-auto"} value={demoUrl}/>
                            </div>
                            <Row justify={"center"}>
                                <Space>
                                    <IconCommon
                                        iconName={"cm-link-regular"}
                                        style={{width: 20}}
                                        className={"cursor-pointer"}
                                        onClick={() => copyLink(demoUrl)}
                                    />
                                    <IconCommon
                                        iconName={"cm-share-regular"}
                                        style={{width: 20}}
                                        className={"cursor-pointer"}
                                        onClick={() => window.open(demoUrl, "_blank")}
                                    />
                                </Space>
                            </Row>
                        </div>
                    </Col>
                )}
            </Row>
        </Modal>
    );
};

export default QrModal;
